<template>
	<div class="admin-drawer">
		<div class="admin-drawer-top">
			<GlobalLogo class="admin-drawer__logo" @click="router.push(localePath('/'))" />
			<v-divider class="admin-drawer__divider" />
			<v-list density="compact">
				<AccordionList class="admin-drawer__accordion">
					<AccordionItem class="admin-drawer__admin-accordion-item" :default-opened="true">
						<template #summary>ADMIN</template>
						<template #icon>
							<GlobalIcon name="arrow-down" :height="16" />
						</template>
						<NuxtLink
							v-for="tab in profileMenuData.admin.tabs.filter((tab) => store.getPermission(tab.requieredPermission))"
							:key="tab.href"
							:to="localePath(tab.href)"
							@click="adminPanelStore.setActiveTab(tab.title)">
							<v-list-item
								:title="tab.title"
								:value="tab"
								:class="{ 'v-list-item--selected': tab.title.toLowerCase() === adminPanelStore.getActiveTab?.toLowerCase() }"
								@click="adminPanelStore.setActiveTab(tab.title)">
								<template #prepend>
									<GlobalIcon v-if="tab.icon" :name="tab.icon" :height="18" />
								</template>
							</v-list-item>
						</NuxtLink>
					</AccordionItem>
				</AccordionList>
			</v-list>
		</div>

		<!-- LOGOUT BUTTON -->
		<v-list class="admin-drawer-bottom" density="compact">
			<v-divider class="admin-drawer__divider" />
			<div class="admin-drawer__logout-container">
				<ButtonCustom class="admin-drawer__logout-btn" icon-before="logout" @click="logout">{{
					$t('modules.admin_module.drawer.logout')
				}}</ButtonCustom>
			</div>
		</v-list>
	</div>
</template>

<script setup lang="ts">
// @ts-ignore typescript error
import { AccordionList, AccordionItem } from 'vue3-rich-accordion'

const store = useUserStore()
const adminPanelStore = useAdminPanelStore()
const router = useRouter()
const localePath = useLocalePath()

const logout = () => {
	store.logout()
	router.push(localePath('/'))
}
</script>

<style lang="scss">
@import './Drawer';
</style>
